import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';
import { RadioGroup } from '../../../components/ui/radio-group-list';
import { yesNoDefaultValue } from '../../../utils/misc';

export const schema = z.object({
  isResident: z.enum(['yes', 'no']),
});

function extractDefaults({ patient }) {
  return {
    isResident: yesNoDefaultValue(patient?.isResident),
  };
}

function transformValues({ isResident }) {
  return {
    patient: {
      isResident: isResident === 'yes',
    },
  };
}

export function NhiResidency(props) {
  const { t } = useTranslation('page.details');
  const radioOptions = useMemo(
    () => [
      { value: 'yes', label: t('common:yes') },
      { value: 'no', label: t('common:no') },
    ],
    [t],
  );

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t('nhi-residency.title')}</h1>
        <p className="mb-5">{t('nhi-residency.text')}</p>
        <div className="space-y-5">
          <RadioGroup
            orientation="horizontal"
            name="isResident"
            options={radioOptions}
            labelVariant="sm"
            description={t('nhi-residency.residentText')}
          />
        </div>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
